import React, {useEffect, useRef, useState} from "react";
import CambioIdioma from "../scripts/CambioIdioma";
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
import HipervinCole from "../DOM/HipervinCole";
export default function Dosbancos(){
    const _updateFiltros= useStoreGlobal(useShallow((state) => state._updateFiltros));
    const indicadores = useRef(null);
    const BieBise = useRef(null);
    const [selectedIndicadores, setOptionIndicadores] = useState("");
    const [selectedBie, setOptionBie] = useState("");
    let var_ingles = "es";
    if (window.location.href.indexOf("en.") > -1) {
        var_ingles = "en";
    }
    const handleChange = (event) => {
        const valorBise = event.target.value;
        setOptionIndicadores(valorBise);
        _updateFiltros({radioIndicador: valorBise});
        HipervinCole(
            "Indicadores",
            var_ingles
        );
    }
    const handleChangeBie = (event) => {
        const valorBie = event.target.value;
        setOptionBie(valorBie);
        let campo = document.getElementById('inputQ').value.trim().replace(/['°|@_=¿?¡!:/<>()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " ");
        if (campo.length > 2) {
            _updateFiltros({textoBusqueda: campo});
        }
        _updateFiltros({radioIndicador: valorBie});
        HipervinCole(
            "BieBise",
            var_ingles
        );
    }
    useEffect(() => {
        if (indicadores !== null) {
            CambioIdioma.valida(var_ingles, indicadores);
        }
        if (BieBise !== null) {
            CambioIdioma.valida(var_ingles, BieBise);
        }
        _updateFiltros({radioIndicador:"BancoBise"});
    }, [indicadores,BieBise]);
    return(
        <div className="col-md-12 todo" id="clasbancos" style={{marginBottom:"15px"}}>
            <fieldset>
                <legend></legend>
                    <div className="row" style={{paddingLeft: "15px"}}>
                        <div className="tamChec form-check form-check-inline col-sm-12 col-md-12 col-lg-12">
                            <label className="form-check-label" htmlFor="radioIndicador">
                                <input type="radio" className="form-check-input" onChange={handleChange}  value="BancoBise" id="radioIndicador" name="tipoBusquedaBancos" defaultChecked={true}/>
                                <label id="BancoBISE" htmlFor="BancoBISE" ref={indicadores}>Banco de Indicadores</label>
                            </label>
                        </div>
                            <div className="tamChec form-check form-check-inline col-sm-12 col-md-12 col-lg-12">
                                <label className="form-check-label" htmlFor="radioBie">
                                    <input type="radio" className="form-check-input" onChange={handleChangeBie} value="BancoBieBise" id="radioBie" name="tipoBusquedaBancos" />
                                    <label id="BancoBIE"  htmlFor="BancoBIE" ref={BieBise}>Banco de Información Económica (BIE)</label>
                                </label>
                            </div>
                    </div>
            </fieldset>
        </div>
    )
}

